import { getFormattedDisplayNameForEqlField } from '@modules/common/components/EqlFieldsAutoComplete/helpers';
import { EqlFieldName } from '@modules/common/constants';
import { getFieldNameFromEqlField } from '@modules/common/utils';
import { QuantifyReportTableLabelCell } from '@modules/quantify/components/QuantifyReportTableWidget/QuantifyReportTableLabelCell';
import { QuantifyQuery } from '@modules/quantify/store/types';
import { GridColDef } from '@mui/x-data-grid-pro';
import { EqlFieldValueType, LabelType } from 'generated/graphql';
import { FieldNames } from 'v2/core/entities/fields';

interface getLabelColumnParams {
  groupBy: QuantifyQuery['groupByField'];
  isCompactTableVariant?: boolean;
  hasCoOccurringDataPointInData: boolean;
  shouldRemoveFileUploadPrefix: boolean;
  isUnifiedFieldEnabled: boolean;
}

export function getLabelColumn({
  groupBy,
  isCompactTableVariant,
  hasCoOccurringDataPointInData,
  shouldRemoveFileUploadPrefix,
  isUnifiedFieldEnabled,
}: getLabelColumnParams) {
  const headerName = groupBy
    ? getFormattedDisplayNameForEqlField({
        eqlField: groupBy,
        shouldRemoveFileUploadPrefix,
        isUnifiedFieldEnabled,
      })
    : '';
  const fieldName = groupBy ? getFieldNameFromEqlField(groupBy) : undefined;
  const labelType =
    fieldName === FieldNames.Reason ? LabelType.Reason : LabelType.Aspect;

  const getMinWidth = () => {
    if (groupBy?.field === EqlFieldName.Reason) {
      return isCompactTableVariant ? 250 : 300;
    }
    return isCompactTableVariant ? 180 : 200;
  };

  const labelColumn: GridColDef = {
    field: 'label',
    headerName,
    // To accommodate for lengthy names, we increase the minWidth.
    minWidth: getMinWidth(),
    flex: 1,
    sortingOrder: ['asc', 'desc'],
    type: groupBy?.valueType === EqlFieldValueType.Number ? 'number' : 'string',
    headerAlign: 'left',
    align: 'left',
    display: 'flex',
    renderCell: (params) => (
      <QuantifyReportTableLabelCell
        params={params}
        shouldWrapLabel={isCompactTableVariant}
        hasCoOccurringDataPointInData={hasCoOccurringDataPointInData}
        labelType={labelType}
      />
    ),
    sortable: false,
  };

  return labelColumn;
}
